import { render } from "./QuizScreen.vue?vue&type=template&id=653c2320&lang=true"
import script from "./QuizScreen.vue?vue&type=script&lang=js"
export * from "./QuizScreen.vue?vue&type=script&lang=js"

import exportComponent from "/home/bshipaa/sites/app.bitesizehipaa.com/bss/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__